import styled from 'styled-components'
import Body from 'syf-component-library/ui/typography/Body'

export const AddressText = styled(Body)`
  font-size: 12px;
  padding: 0;
  margin: 0;
  display: block;
`
